/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AppointmentsAppointment model module.
 * @module model/AppointmentsAppointment
 * @version v0.3
 */
export default class AppointmentsAppointment {
  /**
   * Constructs a new <code>AppointmentsAppointment</code>.
   * @alias module:model/AppointmentsAppointment
   * @class
   * @param patientId {String} ID of the Patient you want to book an appointment with
   * @param appointmentTypeId {String} the appointment type id you would like to book
   * @param fromDate {String} when should the appointment be scheduled
   */
  constructor(patientId, appointmentTypeId, fromDate) {
    this.patientId = patientId;
    this.appointmentTypeId = appointmentTypeId;
    this.fromDate = fromDate;
  }

  /**
   * Constructs a <code>AppointmentsAppointment</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AppointmentsAppointment} obj Optional instance to populate.
   * @return {module:model/AppointmentsAppointment} The populated <code>AppointmentsAppointment</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AppointmentsAppointment();
      if (data.hasOwnProperty('patient_id'))
        obj.patientId = ApiClient.convertToType(data['patient_id'], 'String');
      if (data.hasOwnProperty('appointment_type_id'))
        obj.appointmentTypeId = ApiClient.convertToType(data['appointment_type_id'], 'String');
      if (data.hasOwnProperty('from_date'))
        obj.fromDate = ApiClient.convertToType(data['from_date'], 'String');
      if (data.hasOwnProperty('calendar_id'))
        obj.calendarId = ApiClient.convertToType(data['calendar_id'], 'String');
      if (data.hasOwnProperty('is_initial_appointment'))
        obj.isInitialAppointment = ApiClient.convertToType(data['is_initial_appointment'], 'Boolean');
      if (data.hasOwnProperty('metadata'))
        obj.metadata = ApiClient.convertToType(data['metadata'], {'String': Object});
    }
    return obj;
  }
}

/**
 * ID of the Patient you want to book an appointment with
 * @member {String} patientId
 */
AppointmentsAppointment.prototype.patientId = undefined;

/**
 * the appointment type id you would like to book
 * @member {String} appointmentTypeId
 */
AppointmentsAppointment.prototype.appointmentTypeId = undefined;

/**
 * when should the appointment be scheduled
 * @member {String} fromDate
 */
AppointmentsAppointment.prototype.fromDate = undefined;

/**
 * the specific calendar you would like to book
 * @member {String} calendarId
 */
AppointmentsAppointment.prototype.calendarId = undefined;

/**
 * whether this is the patient's initial appointment
 * @member {Boolean} isInitialAppointment
 * @default false
 */
AppointmentsAppointment.prototype.isInitialAppointment = false;

/**
 * Any JSON-formatted data you want to associate with this object
 * @member {Object.<String, Object>} metadata
 */
AppointmentsAppointment.prototype.metadata = undefined;

